// eslint-disable-next-line react-hooks/exhaustive-deps
import React, { useEffect, useState } from "react";
import MPaper from "Utils/Helpers/MPaper";
import AddBlogsData from "./components/Add";
import { Grid2 } from "@mui/material";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setBlogData } from "../../../../Redux/slices/mngrSlice";
import { useDispatch, useSelector } from "react-redux";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { get_blogs } from "http/components/Blogs";
import TableBlogsData from "./components/Table";

export default function BlogsData() {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);
  const { blog } = useSelector((state) => ({
    blog: state.mngr.blog,
  }));

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (blog || (data && data.paginattion.page !== page)) getData();
  }, [blog, page]);

  const getData = async () => {
    dispatch(HandleLoading(true));
    const response = await get_blogs(page);
    if (CheckApiStatus(response)) {
      setData(response.data);
    }
    dispatch(setBlogData(false));
    dispatch(HandleLoading(false));
  };

  const onChangePage = (new_page) => {
    setPage(new_page);
  };

  return (
    <Grid2 container spacing={2}>
      <Grid2 item size={{ xs: 12 }}>
        <MPaper label={"New Blog"} content={<AddBlogsData />} />
      </Grid2>
      <Grid2 item size={{ xs: 12 }}>
        <MPaper
          label={"Blogs list"}
          content={
            data && <TableBlogsData data={data} onChangePage={onChangePage} />
          }
          defaultExpanded={true}
        />
      </Grid2>
    </Grid2>
  );
}
